import React from "react";
import { CustomIconButton } from "../../..";
import { icon } from "../../../icon-component";
import styles from "./SidePanelContent.module.css";

export default function SidePanelContent({
	autoTranslate = "yes",
	children,
	className = "",
	closeButtonOnRight = false,
	headerClassName = "",
	onClose,
	secondaryActions = null,
	titleDesc = null,
	titleDescClassName = "",
	title,
}) {
	return (
		<div className={styles.panel}>
			<div
				className={`${styles.panel__header} ${closeButtonOnRight ? styles["panel__header--closeOnRight"] : ""}`}
			>
				<CustomIconButton
					className={styles.header__icon}
					data-testid="close.sp.btn"
					icon={icon.faTimes}
					iconClassname={styles["header__icon--large"]}
					onClick={onClose}
				/>
				<span className={`${styles.header__text} ${headerClassName}`} translate={autoTranslate}>
					{title}
					{titleDesc && <span className={`${titleDescClassName}`}>{titleDesc}</span>}
				</span>
				{secondaryActions && <span className={styles.header__secondaryActions}>{secondaryActions}</span>}
			</div>
			<div className={`${styles.panel__content} ${className}`}>{children}</div>
		</div>
	);
}
